import React, { useMemo } from 'react';
import styles from './DevCardStats.module.scss';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { BarChart } from '../../BarChart/index.ts';
import { CardDataController } from '@colonist/game-card-types';
import { UIGameCard } from '../../../../../common/UIGameCard/index.ts';
import { T } from '@colonist/ui';
import { useGameStore } from '../../../../../store/GameStoreContext.ts';
export const DevCardStats = ()=>{
    const { gameEndData } = useUIGameEndContext();
    const activeDevelopmentAndProgressCardTypes = useGameStore((state)=>state.gameMode.activeDevelopmentAndProgressCardTypes);
    const translationKeyContext = useGameStore((state)=>state.gameMode.translationKeyContext);
    const activeDevelopmentCards = CardDataController.getCardEnumsOfTypes(activeDevelopmentAndProgressCardTypes);
    const resourceCardsCountMap = useMemo(()=>{
        const countMap = {};
        gameEndData.endGameState.developmentCardStats.forEach((num)=>{
            if (countMap[num] === undefined) {
                countMap[num] = 0;
            }
            countMap[num] += 1;
        });
        return countMap;
    }, [
        gameEndData
    ]);
    const chartData = useMemo(()=>activeDevelopmentCards.map((cardId)=>{
            var _resourceCardsCountMap_cardId;
            return {
                label: /*#__PURE__*/ React.createElement(UIGameCard, {
                    cardEnum: cardId,
                    className: styles.card,
                    showTipTitle: true
                }),
                value: (_resourceCardsCountMap_cardId = resourceCardsCountMap[cardId]) !== null && _resourceCardsCountMap_cardId !== void 0 ? _resourceCardsCountMap_cardId : 0
            };
        }), [
        activeDevelopmentCards,
        resourceCardsCountMap
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.devCards.cardsDrawn',
            options: {
                context: translationKeyContext
            }
        }
    })), /*#__PURE__*/ React.createElement(BarChart, {
        chartData: chartData
    }));
};
